const PI = Math.PI;
const TAU = PI * 2;
const HALF_PI = PI / 2;
const THIRD_PI = PI / 3;
const QUARTER_PI = PI / 4;
const SIXTH_PI = PI / 6;
const INV_PI = 1 / PI;
const INV_TAU = 1 / TAU;
const INV_HALF_PI = 1 / HALF_PI;
const DEG2RAD = PI / 180;
const RAD2DEG = 180 / PI;
const PHI = (1 + Math.sqrt(5)) / 2;
const SQRT2 = Math.SQRT2;
const SQRT3 = Math.sqrt(3);
const SQRT2_2 = SQRT2 / 2;
const SQRT3_2 = SQRT3 / 2;
const THIRD = 1 / 3;
const TWO_THIRD = 2 / 3;
const SIXTH = 1 / 6;
let EPS = 1e-6;
export {
  DEG2RAD,
  EPS,
  HALF_PI,
  INV_HALF_PI,
  INV_PI,
  INV_TAU,
  PHI,
  PI,
  QUARTER_PI,
  RAD2DEG,
  SIXTH,
  SIXTH_PI,
  SQRT2,
  SQRT2_2,
  SQRT3,
  SQRT3_2,
  TAU,
  THIRD,
  THIRD_PI,
  TWO_THIRD
};
